import { AuditLog } from '@shared/models/audit-log.model';
import { Money } from '@shared/models/money.model';

import { ReduceToClearEnum } from '../enum/reduce-to-clear.enum';

export interface ReduceToClearListContent {
  docNo: string;
  refRequestNo: string;
  storeCode: string;
  storeName: string;
  storeCodeName: string;
  productName: string;
  barcode: string;
  status: ReduceToClearEnum;
  expiryDate: Date;
  rtcAmount: Money;
  remainQty: number;
  discount: number;
  discountDateTo: Date;
  discountDateFrom: Date;
  createdBy: string;
  createdDate: Date;
  auditLogs: AuditLog[];
}

export const reduceToClearStatusList = [
  { value: '', label: 'สถานะทั้งหมด' },
  { value: ReduceToClearEnum.AWAITING_SCHEDULE, label: 'รอใช้งาน' },
  { value: ReduceToClearEnum.ACTIVE, label: 'ใช้งาน' },
  { value: ReduceToClearEnum.SOLD_OUT, label: 'ขายหมด' },
  { value: ReduceToClearEnum.EXPIRED, label: 'หมดอายุ' }
];

export interface ReduceToClearSearchCriteria {
  searchCriteria?: string;
  page: number;
  size: number;
  status?: string;
  expiryDateFrom?: string;
  expiryDateTo?: string;
  discountDateFrom?: string;
  discountDateTo?: string;
}

export class ReduceToClearViewResponse {
  docNo: string;
  refRequestNo: string;
  status: string;
  createdBy: string;
  createdDate: string;
  items: ReduceToClearItem[];
  nearestExpiryDate: string;
  lastModifiedDate: string;
  auditLogs: AuditLog[];
}

export interface ReduceToClearItem {
  barcode: string;
  articleNo: string;
  productName: string;
  unit: string;
  unitName: string;
  baseUnit: string;
  baseUnitName: string;
  barSize: string;
  unitFactor: number;
  segment: string;
  family: string;
  classCode: string;
  className: string;
  subClass: string;
  vat: boolean;
  retailPrices: RetailPrices;
  wholesalePrices: WholesalePrices;
  expires: Expire[];
  expire: Expire;
  expireRates: ExpireRate[];
}

export interface RequestAmount {
  amount: number;
  currency: string;
}

export class Price {
  amount: number;
  currency: string;

  constructor(amount: number, currency: string) {
    this.amount = amount;
    this.currency = currency;
  }
}

export interface RetailPrices {
  priceIncVat: PriceIncVat;
  vat: Vat;
  priceExcVat: PriceExcVat;
}

export interface PriceIncVat {
  amount: number;
  currency: string;
}

export interface Vat {
  amount: number;
  currency: string;
}

export interface PriceExcVat {
  amount: number;
  currency: string;
}

export interface WholesalePrices {
  priceIncVat: PriceIncVat;
  vat: Vat;
  priceExcVat: PriceExcVat;
}

export class Expire {
  requestQty: number;
  images: string[];
  remainQty: number;
  expiryDate: string;
  status: string;
  requestAmountIncVat: RequestAmountIncVat;

  constructor(
    requestQty: number,
    images: string[],
    expiryDate: string,
    status: string,
    requestAmountIncVat: RequestAmountIncVat,
    remainQty: number
  ) {
    this.requestQty = requestQty;
    this.images = images;
    this.expiryDate = expiryDate;
    this.status = status;
    this.requestAmountIncVat = requestAmountIncVat;
    this.remainQty = remainQty;
  }
}

export interface RequestAmountIncVat {
  amount: number;
  currency: string;
}

export interface ExpireRate {
  from: number;
  to: number;
  discount: number;
  clearPricePerUnit: number;
}
